<template>
  <ColorContext :backgroundColor="backgroundColor">
    <Container tagName="section" class="StandoutFeatureGrid" :style="cssVariables">
      <div class="standoutSection">
        <div class="gridItems">
          <div v-for="feature in content.features"
            :key="feature._key"
            class="item"
          >
            <div class="icon">
              <SanityImage v-if="feature.icon" :asset="feature.icon.asset" />
              <h3 v-if="feature.heading" class="heading">{{ feature.heading }}</h3>
            </div>
            <CtaLink v-if="feature.cta" v-bind="feature.cta" class="cta" />
          </div>
        </div>
      </div>
    </Container>
  </ColorContext>
</template>

<script>
import ColorContext from '~/vue-components/shared/ColorContext.vue'

export default {
  components: {
    ColorContext,
  },
  props: {
    content: Object,
  },
  computed: {
    backgroundColor() {
      return this.content.presentationOptions?.backgroundColor;
    },
    cssVariables() {
      const featuresCount = this.content.features?.length || 0
      const itemsCount = featuresCount
      return {
        '--grid-template-columns': Math.min(itemsCount, 4),
      }
    }
  },
}
</script>

<style scoped>
.StandoutFeatureGrid {
  background-color: var(--background-color);
  padding-top: var(--spacing-15);
  padding-bottom: var(--spacing-15);
}

.standoutSection {
  border-radius: 0;
  padding: var(--spacing-10) var(--spacing-13);
  color: var(--text-color);
}

.item {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  text-align: center;
}

.item + .item {
  margin-top: var(--spacing-12);
}

.icon:deep(img) {
  max-height: 90px;
  min-width: 60px;
  margin: 0 auto
}

.icon + .cta {
  margin-top: var(--spacing-3);
}

.icon:deep(img) + .heading {
  margin-top: var(--spacing-5);
}

.heading {
  font-weight: 600;
}

@media (--screen-lg) {
  .StandoutFeatureGrid {
    background-color: inherit;
    padding-top: 0;
  }

  .standoutSection {
    background-color: var(--background-color);
    border-radius: var(--border-radius);
  }

  .gridItems {
    display: grid;
    grid-template-columns: repeat(var(--grid-template-columns), minmax(0, 1fr));
    gap: var(--spacing-14) var(--spacing-10);
  }

  .item + .item {
    margin-top: 0;
  }
}
</style>
